module.exports = __webpack_public_path__ + "images/architect-logo-fa75601f0a998219a983075c9913201d.jpg";